// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buy-ticket[data-v-19f7e5c7]{\n      color: var(--spainhn-rojo-spainhn);\n      text-align: center;\n      font-family: 'Montserrat';\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n}\n.icon[data-v-19f7e5c7]{\n      width: 55px;\n      height: 55px;\n      flex-shrink: 0;\n}\n.buy-icon[data-v-19f7e5c7]{\n  position: abs;\n  width: 100px;\n  height: 100px;\n  flex-shrink: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
